import './PeriscopeSummaryList.scss';
import { createSonarSelector } from '@lib/selectors';
import { PeriscopeCard } from '@sonar-software/sonar-ts-types';
import { PeriscopeSummary } from './PeriscopeSummary';
import React from 'react';
import { useSonarSelector } from '@hooks';

const periscopesSelector = createSonarSelector((state) => state.application.periscope.cards);

export const PeriscopeSummaryList: React.FC = () => {
	const periscopes = useSonarSelector(periscopesSelector);

	return (
		<>
			{ periscopes.map((periscope: PeriscopeCard, index) =>
				<PeriscopeSummary
					index={ index }
					key={ periscope.id }
					periscope={ periscope } />) }
		</>
	);
};
